import { useState, useEffect } from 'react'; //useMemo
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Unstable_Grid2';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import StringTextField from 'src/components/widgets/string-textfield';
import SearchSelectField from 'src/components/widgets/search-select-field';
import DropdownLocations from 'src/components/dropdown/dropdown-locations';
import { initialValues, validationSchema, handleSubmitted } from './formik';
const parentGroup = { value: '0', label: 'Mặc định' };

export const DetailForm = (props) => {
  const {
    item,
    apiCreate,
    apiDelete,
    apiUpdate,
    ...other
  } = props;

  const [defaultVal, setDefaultVal] = useState(item);
  useEffect(() => {
    if (item) {
      const options = [
        { value: `${item.id}`, label: `${item.name}` },
        parentGroup,
      ];
      setDefaultVal((prev) => ({
        ...prev,
        isLeaf: item.leaf,
        optDefault: `${item.id}`,
        options: options,
        hintName: item.name,
        hintLocation: item.address,
      }));
    } else {
      setDefaultVal((prev) => ({
        ...prev,
        optDefault: '0',
        options: [parentGroup],
      }));
    }
    
    initialValues(formik, item);
  }, [item]);

  const handlerGroupSelected = (item) => {
    const isCreate = item && item.value === '0' ? false : true;
    setDefaultVal((prev) => ({
      ...prev,
      isCreate: isCreate,
    }));
  };

  const formik = useCustomFormik({
    validationSchema: validationSchema(defaultVal),
    onSubmit: async (values, helpers) => {
      handleSubmitted(values, defaultVal, apiCreate, apiDelete, apiUpdate);
    },
  });
  
  return (
    <form onSubmit={formik.handleSubmit} {...other}>
      <Card>
        <CardContent sx={{ px: 1, py: 2 }}>
          <Grid container spacing={3}>
            <Grid xs={12} md={3}>
              <StringTextField
                label="Tên nhóm"
                name="name"
                formik={formik}
                hintValue={defaultVal.isCreate ? '' : defaultVal.hintName}
              />
            </Grid>

            <Grid xs={12} md={3}>
              <SearchSelectField
                label="Thuộc nhóm"
                name="group"
                formik={formik}
                defaultValue={defaultVal.optDefault}
                options={defaultVal.options || []}
                onSelected={handlerGroupSelected}
              />
            </Grid>

            <Grid xs={12} md={6}>
              <DropdownLocations
                label="Chọn địa điểm"
                formik={formik}
                hintValue={defaultVal.isCreate ? '' : defaultVal.hintLocation}
              />
            </Grid>

            <Grid xs={12} md={11} display="flex" 
              sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}
            >
              <SubmitButton formik={formik} isRemove={!defaultVal.isCreate && defaultVal.isLeaf} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </form>
  );
};

DetailForm.propTypes = {
  item: PropTypes.object.isRequired,
};